import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import {BASE_URL} from "../helpers/variables";
import sampleCombine from "xstream/extra/sampleCombine";
import { replace } from 'react-router-redux';
import {
  countSpecialOffersFailed,
  countSpecialOffersSuccess, createSpecialOfferFailed,
  createSpecialOfferSuccess, deleteSpecialOfferFailed,
  deleteSpecialOfferSuccess,
  editSpecialOfferFailed, editSpecialOfferSuccess, getSpecialOffers,
  getSpecialOffersFailed,
  getSpecialOffersSuccess
} from '../actions/specialOffers';

export function requestSpecialOffers(sources) {
  const state$ = sources.STATE;
  const token$ = state$.map(state => state.login.getIn(['userInfo', 'token']));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_SPECIAL_OFFERS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + `api/specialOffers?filter=` +
        (action.payload && action.payload.filter?JSON.stringify(action.payload.filter):JSON.stringify({})),
      category: 'getSpecialOffers',
      method: 'GET',
      headers: {Authorization: token}
    }));

  let httpResponse$ = sources.HTTP
    .select('getSpecialOffers')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => getSpecialOffersSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestSpecialOffersFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('getSpecialOffers')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => getSpecialOffersFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function countSpecialOffers(sources) {
  const state$ = sources.STATE;
  const token$ = state$.map(state => state.login.getIn(['userInfo', 'token']));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.COUNT_SPECIAL_OFFERS)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/specialOffers/count?filter=' +
        (action.payload && action.payload.filter?JSON.stringify(action.payload.filter):JSON.stringify({})),
      category: 'countSpecialOffers',
      method: 'GET',
      headers: {Authorization: token}
    }));

  let httpResponse$ = sources.HTTP
    .select('countSpecialOffers')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => countSpecialOffersSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function countSpecialOffersFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('countSpecialOffers')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => countSpecialOffersFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function createSpecialOffer(sources) {
  const state$ = sources.STATE;
  const token$ = state$.map(state => state.login.getIn(['userInfo', 'token']));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SPECIAL_OFFER)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/specialOffers?access_token=' +
        token,
      category: 'createSpecialOffer',
      method: 'POST',
      send: {
        title:  action.payload.title,
        subtitle: action.payload.subtitle,
        logo: action.payload.logo,
        productId: action.payload.featuredProductId,
      },
      withCredentials: true
    }));

  let httpResponse$ = sources.HTTP
    .select('createSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => createSpecialOfferSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function createSpecialOfferFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('createSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => createSpecialOfferFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterCreateSpecialOfferSuccess(sources) {
  let action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SPECIAL_OFFER_SUCCESS)
    .map(action => replace('/specialOffers'));

  return {
    ACTION: action$,
  }
}

export function deleteSpecialOffer(sources) {
  const state$ = sources.STATE;
  const token$ = state$.map(state => state.login.getIn(['userInfo', 'token']));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_SPECIAL_OFFER)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + `api/specialOffers/${action.payload}?access_token=` +
        token,
      category: 'deleteSpecialOffer',
      method: 'DELETE',
      withCredentials: true
    }));

  let httpResponse$ = sources.HTTP
    .select('deleteSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => deleteSpecialOfferSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function deleteSpecialOfferFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('deleteSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => deleteSpecialOfferFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterDeleteSpecialOfferSuccess(sources) {
  let action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_SPECIAL_OFFER_SUCCESS)
    .map(action => replace('/specialOffers'));

  return {
    ACTION: action$,
  }
}

export function editSpecialOffer(sources) {
  const state$ = sources.STATE;
  const token$ = state$.map(state => state.login.getIn(['userInfo', 'token']));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.EDIT_SPECIAL_OFFER)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + `api/specialOffers/${action.payload.id}?access_token=` +
        token,
      category: 'editSpecialOffer',
      method: 'PATCH',
      send: {
        title:  action.payload.title,
        subtitle: action.payload.subtitle,
        logo: action.payload.logo,
        productId: action.payload.featuredProductId,
      },
      withCredentials: true
    }));

  let httpResponse$ = sources.HTTP
    .select('editSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => editSpecialOfferSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function editSpecialOfferFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('editSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => editSpecialOfferFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function fetchSpecialOffersOnEditSuccess(sources) {
  let httpResponse$ = sources.HTTP
    .select('editSpecialOffer')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => getSpecialOffers());

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/specialOffers.js